// extracted by mini-css-extract-plugin
export var active = "ModalHeader-module--active--6b0c5";
export var closeButton = "ModalHeader-module--closeButton--126dd";
export var fadeInAnimation = "ModalHeader-module--fadeInAnimation--745f8";
export var modalHeader = "ModalHeader-module--modalHeader--bc83e";
export var navigation = "ModalHeader-module--navigation--64519";
export var stepLine = "ModalHeader-module--stepLine--b1272";
export var text = "ModalHeader-module--text--88b73";